// extracted by mini-css-extract-plugin
export default {"custom-modal":"Modal_custom-modal__6cBe4","min-height-80vh":"Modal_min-height-80vh__W8rfJ","modal-content":"Modal_modal-content__pCYnT"};